import { useField } from "formik";
import React from "react";
import { useTranslation } from "react-i18next";
import Tooltip from "react-tooltip-lite";
import { Icon } from "../../../Icon/Icon";
import { PasswordErrorMessageTooltip } from "../../../SharedComponents/PasswordErrorMessageTooltip/PasswordErrorMessageTooltip";
import "./LoginCompleteSetupInput.css";

/**
 *
 * @param {object} props
 * @prop {string} props.label
 */
export const LoginCompleteSetupInput = ({ label, ...props }) => {
  const { t } = useTranslation();
  const [field, meta] = useField(props);

  return (
    <div className="LoginCompleteSetupInput">
      <div className="LoginCompleteSetupInput__title">
        <div className="LoginCompleteSetupInput__title-text">{label}</div>
      </div>
      <input className="LoginCompleteSetupInput__input" {...field} {...props} />
      {meta.touched && meta.error ? (
        <div className="EditableInformationTextInput__error">
          <Tooltip
            padding={0}
            content={
              <PasswordErrorMessageTooltip>
                {t(meta.error)}
              </PasswordErrorMessageTooltip>
            }
          >
            <Icon name="iconNotification" width={20} height={20} />
          </Tooltip>
        </div>
      ) : null}
    </div>
  );
};
